import React from 'react';
import { MdClose } from 'react-icons/md';

import { Chip } from '@material-ui/core';

import { ClearFiltersButton, Container } from './styles';

interface SingleFilterParam {
  condition: boolean;
  label: string | undefined;
  onDelete: () => void;
}

interface ArrayFilterParam<Type> {
  list: Array<Type> | undefined;
  label: (data: Type) => string | undefined;
  onDelete: (data: Type) => void;
}

type FilterParam = SingleFilterParam | ArrayFilterParam<any>;
interface FilterChipsProps {
  filterParams: Array<FilterParam>;
  onClear: () => void;
}

function isArrayFilterParam<Type>(
  param: unknown,
): param is ArrayFilterParam<Type> {
  return Object.prototype.hasOwnProperty.call(param, 'list');
}

function FilterChips({ filterParams, onClear }: FilterChipsProps) {
  const hasFilter = () =>
    filterParams.some((filterParam) =>
      isArrayFilterParam(filterParam)
        ? filterParam.list && filterParam.list.length > 0
        : !!filterParam.condition,
    );

  const renderChip = (filterParam: FilterParam) => {
    if (isArrayFilterParam(filterParam)) {
      return filterParam.list?.map((param) => (
        <Chip
          key={filterParam.label(param)}
          label={filterParam.label(param)}
          style={{
            background: 'rgba(255, 153, 184, 0.25)',
            borderRadius: '5px',
          }}
          onDelete={() => filterParam.onDelete(param)}
          deleteIcon={<MdClose />}
        />
      ));
    }

    return (
      !!filterParam.condition && (
        <Chip
          label={filterParam.label}
          style={{
            background: 'rgba(255, 153, 184, 0.25)',
            borderRadius: '5px',
          }}
          onDelete={filterParam.onDelete}
          deleteIcon={<MdClose />}
        />
      )
    );
  };

  return (
    <>
      {hasFilter() && (
        <Container>
          {filterParams.map((param) => renderChip(param))}

          <ClearFiltersButton type="button" onClick={onClear}>
            Limpar
          </ClearFiltersButton>
        </Container>
      )}
    </>
  );
}

export default FilterChips;
